<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bgK6UM/tc-custom/9781614233381.jpg?1695318743323" alt="This image is the cover for the book Chronicles of a Rochester Major Crimes Detect"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chronicles of a Rochester Major Crimes Detect
      </h1>
      <p class="bookDescription body article font2">
        <b>A longtime Rochester, New York, police detective tells the behind-the-scenes stories of four of his most memorable cases.</b><br/>  <br/> Patrick Crough served more than twenty years as a Monroe County Major Crimes detective, where he investigated some of the region’s most tragic crimes. They include horrifying acts, like that of a Valentine’s Day killing rampage that left four people dead, as well as the case against Ed Laraby, the serial rapist who terrorized women in Rochester and Monroe County. But there are also stories of heroism and bravery: strangers coming to the aid of those in peril, parents who laid down their lives to save their children, and the team of people who put violent criminals behind bars.<br/>  <br/> In these pages, Crough details four of his most memorable cases—in which he was forced to confront evil and chose to pursue truth.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Crough
      </h2>
      
      <p class="authorDescription body article">Retired investigator sergeant Patrick Crough served thirty years with the Monroe County Sheriff 's Office. After serving in the Marine Unit and on the Road Patrol, he worked assignments in the Violent Warrant Squad and the Vice and Narcotics Unit as an undercover officer. When assigned to the Major Crimes Unit, he investigated some of the most heinous crimes committed in the Greater Rochester area for over two decades. He also served as a hostage negotiator on the Monroe County Sheriff 's Hostage Rescue Team. In May 2009, Patrick Crough authored and published The Serpents among Us: How to Protect Your Children from Sexual Predators; A Police Investigator's Perspective, to educate parents about the manipulative techniques child predators utilize to gain access to a child they are targeting. When Patrick Crough retired from the Monroe County Sheriff 's Office in April 2010, he held the rank of investigator sergeant, in charge of the Major Crimes Unit and commander of the Hostage Rescue Team. He currently teaches basic and advanced interrogation techniques to other police officers and detectives for BowMac Law Enforcement Consultants and serves as president of Millstone Justice Children's Advocacy Organization, a nonprofit corporation that is dedicated to teaching parents how to keep their children safe from child predators.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ea3162b